import { render, staticRenderFns } from "./TheAccountAdmin.vue?vue&type=template&id=3851bbc0&scoped=true"
import script from "./TheAccountAdmin.vue?vue&type=script&lang=js"
export * from "./TheAccountAdmin.vue?vue&type=script&lang=js"
import style0 from "./TheAccountAdmin.vue?vue&type=style&index=0&id=3851bbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851bbc0",
  null
  
)

export default component.exports